import React, { useEffect } from "react";
import Table from "../table/Table";
import { useSelector } from "react-redux";
import { useFetchOrderByUserQuery } from "../../store/api/OrderSlice";

const MyOrders = () => {
  const authState = useSelector((state) => state.auth); 
  const user = useSelector((state) => state.auth.user);
  const token = useSelector((state) => state.auth.token);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { data } = useFetchOrderByUserQuery(user?._id, {
    skip: !user?._id,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  useEffect(() => {
  }, [authState]); 

  return (
    <div className="overlow-hidden">
      <h5>Name : {user?.name}</h5>
      <h5 className="pb-10 ">Email : {user?.email}</h5>
      <div className="mb-10">
        <h2 className="text-xl text-black font-semibold mb-5">My Orders</h2>
        <Table data={data} />
      </div>
    </div>
  );
};

export default MyOrders;
